// icons

export const ForGroundImg = require('../../../assets/img/login_bg.png')
export const  BackGroundImg = require('../../../assets/img/login.png')
export const LogoImg  = require('../../../assets/img/logo.png')
